import axios from 'axios';
import { backendHost } from '../../config';

export const getStatistics = (params) => {
    return axios.get(`${backendHost}/api/admin/statistics`, {params});
};